// Painted artwork used across the landing page. A slot stays null until its file exists in public/images.

export type ArtAsset = {
    src: string
    width: number
    height: number
}

export type ArtKey = 'heroLandscape' | 'cloud' | 'tree' | 'nightLandscape' | 'meadow'

export const art: Record<ArtKey, ArtAsset | null> = {
    heroLandscape: { src: '/images/hero-landscape.jpg', width: 3168, height: 1344 },
    cloud: { src: '/images/cloud.jpg', width: 2752, height: 1536 },
    tree: { src: '/images/tree.jpg', width: 1792, height: 2400 },
    nightLandscape: { src: '/images/dusk-valley.jpg', width: 3168, height: 1344 },
    meadow: { src: '/images/meadow.jpg', width: 1856, height: 2304 }
}
